/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 4ade0ef98b00
 */

import { CommandContext, StricliProcess } from "@stricli/core";

export interface LocalContext extends CommandContext {
  readonly process: StricliProcess;
}

export function buildContext(process: NodeJS.Process): LocalContext {
  return { process: process as StricliProcess };
}
